// extracted by mini-css-extract-plugin
export default {"section":"Newborn_section__ygpTZ","container":"Newborn_container__-oN78","container__photo":"Newborn_container__photo__rJ9dK","photo":"Newborn_photo__sDOFC"};